import { makeAutoObservable } from 'mobx';
import { validateCandleTrail } from './validateCandleTrail';

export class CandleTrailData {
  candleDuration = 1;
  timeUnit = 'MINUTES';
  usePrePostMarketData = false;
  breakBy = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.candleDuration = 1;
    this.timeUnit = 'MINUTES';
    this.usePrePostMarketData = false;
    this.breakBy = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateCandleTrail(this.candleDuration);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      timeUnit: this.timeUnit,
      usePrePostMarketData: this.usePrePostMarketData,
      breakBy: this.breakBy,
    };
  };

  //specific methods
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setTimeUnit = (string) => {
    this.timeUnit = string;
  };
  setUsePrePostMarketData = (bool) => {
    this.usePrePostMarketData = bool;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
}
